<rt-dropdown [width]="DropdownWidth.SmallX">
  @for (option of options; track trackByIndex($index, option)) {
    <rt-dropdown-item [isSelected]="isActive(option.value)" (click)="select(option.value)">
      <span [style.font-size.em]="option.value || null">
        {{ option.label | translate }}
      </span>
    </rt-dropdown-item>
  }
</rt-dropdown>
